module.exports = __webpack_public_path__ + "static/media/icon-plan-ani.d55aba6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/icon-plan-ani.png
// module id = 652
// module chunks = 1